import { PROFILE } from "@/graphql/queries/profile";
import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";

export default function useChatWidgetRouter() {
    const [activeChatWidget, setActiveChatWidget] = useState(null);

    const { data: { profile } = {} } = useQuery(PROFILE, {
        fetchPolicy: "cache-first",
    });

    const gender = profile?.gender ?? null;

    useEffect(() => {
        // This means profile is surly loaded
        if (gender) {
            setActiveChatWidget("OnlineHawzahChatWidget");
        }
    }, [gender]);

    useEffect(() => {
        console.debug("*** activeChatWidget changed to ***", activeChatWidget);
    }, [activeChatWidget]);

    return activeChatWidget;
}
